<template>
  <v-select
    ref="countryCode"
    v-model="countryCode"
    :items="countries"
    :rules="[v => !!v || 'This field is required']"
    :label="label"
    required
    @input="handleInput"
  ></v-select>
</template>
<script>
import { formValidation } from '../../mixins/validation.mixins';

const _ = require('lodash');

export default {
  mixins: [formValidation],
  props: {
    value: String,
    label: String,
  },
  data() {
    return {
      countryCode: this.value,
    };
  },
  computed: {
    countries() {
      const countries = this.$store.getters['utils/getCountries'];
      return _.chain(countries).map(country => ({
        text: `${country.code} - ${country.name}`,
        value: country.code,
      })).sortBy(country => country.text).value();
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.countryCode);
    },
  },
};
</script>
